const SET_SERVICE_WORKER_REGISTRATION = 'SET_SERVICE_WORKER_REGISTRATION'

export { SET_SERVICE_WORKER_REGISTRATION }
